import styled from 'styled-components'

export const CommentArea = styled.div`
  position: relative;
  border: 1px solid rgba(32, 32, 32, 0.2);
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  margin-bottom: 10px;
`
export const TextAreaControls = styled.div`

`
export const CommentButtonsLeft = styled.div`
 position: absolute;
 display: flex;
 left: 5px;
 bottom: 0;

 button {
    :hover {
        background: rgba(32, 32, 32, 0.05);
        border-radius: 20px;
        color: rgba(32, 32, 32, 1);
    }
 }
`
export const CommentButtonsRight = styled.div`
 position: absolute;
 display: flex;
 right: 5px;
 bottom: 0;
`
export const LeaveCommentBg = styled.div`
  width: 40px;
  height: 40px; 
  background: rgba(10, 161, 244, 1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const FormatTextArea = styled.div`
border: none;
box-shadow: none;
border-radius: none;
`
